import { RouteObject } from "react-router-dom";
import { PortalRouteObject } from "../pages/portal/Portal.Route";

export const PortalShell: RouteObject[] = [PortalRouteObject];
